import { isText } from "../../utils/index.js";
export const transformToJson = (result, customResolvers) => customResolvers ? result.children.map(node => transformDomNode(node, customResolvers)) : result.children;
const nodeIdentity = (node) => node;
const transformDomNode = (node, { resolveDomHtmlNode, resolveDomTextNode }) => {
    if (isText(node)) {
        return resolveDomTextNode ? resolveDomTextNode(node) : nodeIdentity(node);
    }
    return resolveDomHtmlNode
        ? resolveDomHtmlNode(node, (node) => transformDomNode(node, { resolveDomHtmlNode, resolveDomTextNode }))
        : nodeIdentity(node);
};
